import tree from './tree'

var routes = [
    {
        path: '',
        exact: true,
        component: () => import('./dashboard'),
        display: 'dashboard',
    },
]

function extractRoutes(node) {
    if (node.component) {
        routes.push({ ...node })
    }

    if (node.children) {
        node.children.forEach(s => extractRoutes(s))
    }
}

tree.forEach(node => extractRoutes(node))

export default routes
